import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";
import Select from "react-select";


const PlanifLines = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [recepDate, setRecepDate] = useState("");
    const [serviceType, setserviceType] = useState("");
    const [project, setproject] = useState("");
    const [servicesType, setServicesType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [projects, setProjects] = useState([]);
    const [start_route, setStartRoute] = useState("");
    const [end_route, setEndRoute] = useState("");
    const [message, setMessage] = useState("");
    const [modalData, setModalData] = useState(null); // Orden seleccionada
    const [recepcionData, setRecepcionData] = useState({}); // { LineNum: cantidad }
    const [establecimiento, setEstablecimiento] = useState("");
    const [puntoEmision, setPuntoEmision] = useState("");
    const [numeroFolio, setNumeroFolio] = useState("");
    const [comentariosPorLinea, setComentariosPorLinea] = useState({});


     // Obtener la lista de artículos desde el backend
    const fetchItems = async () => {
        try {
            const sapUser = JSON.parse(localStorage.getItem("sapUser"));
            const whsCode = sapUser?.WhsCode || "";
            const Company = sapUser?.CompanyDB || "";

            const response = await apiClient.get("/inventario/recepcion/traslado", {
                params: {
                    whsCode: whsCode, company: Company
                }
            });

            //console.log("Datos recibidos:", response.data);

            if (!Array.isArray(response.data)) {
                throw new Error("Los datos recibidos no son un array");
            }

            // Aplicar agrupación según la opción seleccionada
            const groupedData = response.data.reduce((acc, order) => {
                let key;
                    key = `${order.DocEntry}`;


                if (!acc[key]) {
                    acc[key] = {
                        DocEntry: order.DocEntry,
                        DocNum: order.DocNum,
                        CardCode: order.CardCode,
                        CardName: order.CardName,
                        DocDate: order.DocDate,
                        DocDueDate: order.ShipDate,
                        Comments: order.Comments,
                        Orders: [],
                    };
                }
                acc[key].Orders.push(order);
                return acc;
            }, {});

            const formattedData = Object.values(groupedData);
            setOrders(formattedData);
            setFilteredOrders(formattedData);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching orders", err);
            setError("Error al obtener órdenes de ventas.");
        }
    };
    
    useEffect(() => {
    fetchItems(); // carga inicial
    }, []);

    useEffect(() => {
        filterOrders(); // cada vez que cambia la búsqueda o las órdenes
    }, [searchTerm, orders]);

    const filterOrders = () => {
        if (!searchTerm) {
            setFilteredOrders(orders);
            return;
        }

        const term = searchTerm.toLowerCase();

        const filtered = orders.filter(order => {
            const docNum = String(order.DocNum || "").toLowerCase();
            const cardName = String(order.CardName || "").toLowerCase();
            const docDate = formatDateUTC(order.DocDueDate);
            const comments = String(order.Comments || "").toLowerCase();

            return (
                docNum.includes(term) ||
                cardName.includes(term) ||
                docDate.includes(term) ||
                comments.includes(term)
            );
        });

        setFilteredOrders(filtered);
    };


    // Componente expandible para mostrar líneas de orden
    const ExpandedComponent = ({ data }) => (
        <div className="p-2">
            <h6 style={{ fontSize: "12px" }}>Detalles de la Orden</h6>
            <table className="table table-sm table-bordered" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Insumo</th>
                        <th>Descripción</th>
                        <th>Cantidad Pedida</th>
                        <th>Cantidad Pendiente</th>
                        <th>Almacen Origen</th>
                        <th>Almacen Destino</th>
                    </tr>
                </thead>
                <tbody>
                    {data.Orders.map((order, index) => (
                        <tr key={index}>
                            <td>{order.ItemCode}</td>
                            <td>{order.Dscription}</td>
                            <td>{order.Quantity}</td>
                            <td>{order.OpenQty}</td>
                            <td>{order.Origen}</td>
                            <td>{order.Destino}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    const formatDateUTC = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        if (isNaN(date)) return "";

        // Corregir la hora sumando 3 horas manualmente
        date.setHours(date.getHours() + 3);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const handleRecepcionar = (order) => {
        setModalData(order);
        const initialData = {};
        order.Orders.forEach(line => {
            initialData[line.LineNum] = ""; // Inicial vacío
        });
        setRecepcionData(initialData);

        // Inicializar comentarios por línea (para validación min 10 / max 100)
        const initialComments = {};
        order.Orders.forEach(line => {
            initialComments[line.LineNum] = "";
        });
        setComentariosPorLinea(initialComments);
    };


    const columns = [
        {
            name: "Nro Documento",
            selector: (row) => row.DocNum,
            sortable: true,
            width: "140px",
        },
        {
            name: "Proveedor",
            selector: (row) => "Traslado Interno",
            sortable: true,
            width: "200px",
        },
        {
            name: "Fecha",
            selector: (row) => formatDateUTC(row.DocDate),
            sortable: true,
            width: "120px",
        },
        {
            name: "Fecha Recepción",
            selector: (row) => formatDateUTC(row.DocDueDate),
            sortable: true,
            width: "120px",
        },
        {
            name: "Comentario",
            selector: (row) => row.Comments,
            sortable: true,
            width: "350px",
        },
        {
            name: "Acciones",
            cell: (row) => (
                <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleRecepcionar(row)}
                    title="Recepcionar Orden"
                >
                    <i className="bi bi-box-arrow-in-down me-1"></i> Recepcionar
                </button>
            ),
            iignoreRowClick: true,
            width: "140px"
        },
    ];

    const confirmarRecepcion = async () => {
        const lines = modalData.Orders
            .filter(line => parseFloat(recepcionData[line.LineNum]) > 0)
            .map(line => ({
                BaseEntry: modalData.DocEntry,
                BaseLine: line.LineNum,
                BaseType: "InventoryTransferRequest", // Solicitud de traslado
                ItemCode: line.ItemCode,
                Quantity: parseFloat(recepcionData[line.LineNum]),
                FreeText: comentariosPorLinea[line.LineNum] || ""
            }));

        if (lines.length === 0) {
            alert("Debe ingresar al menos una cantidad válida a recepcionar.");
            return;
        }

        if (!establecimiento.trim() || !puntoEmision.trim() || !numeroFolio.trim()) {
            alert("Debe completar Establecimiento, Punto de Emisión y Número de Folio antes de confirmar la recepción.");
            return;
        }

        for (const line of modalData.Orders) {
            const qty = parseFloat(recepcionData[line.LineNum]);
            const comentario = comentariosPorLinea[line.LineNum]?.trim() || "";
            if (qty > 0 && comentario.length < 10) {
                alert(`Debe ingresar un comentario para el artículo ${line.ItemCode} antes de confirmar.`);
                return;
            }
            if (qty > 0 && comentario.length > 100) {
                alert(`El comentario para el artículo ${line.ItemCode} no puede superar 100 caracteres.`);
                return;
            }
        }

        const payload = {
            CardCode: modalData.CardCode, // Asegurate de que modalData tenga CardCode
            U_ESTA: establecimiento,
            U_PEMI: puntoEmision,
            FolioPrefixString: "RE",
            FolioNumber: numeroFolio,
            StockTransferLines: lines
        };

        try {
            console.log(payload);
            const response = await apiClient.post("/inventario/recepcion/traslado", { orders: payload });
            const results = Array.isArray(response.data) ? response.data : (response.data?.results || []);

            const successCount = results.filter(r => r.status === "success").length;
            const warningCount = results.filter(r => r.status === "warning").length;
            const errorCount = results.filter(r => r.status === "error").length;

            const lines = [];
            if (successCount > 0) lines.push(`${successCount} traslado recepcionado con éxito.`);
            if (warningCount > 0) lines.push(`${warningCount} traslado recepcionado sin cambios.`);
            if (errorCount > 0) lines.push(`${errorCount} error(es) en la recepción.`);

            // Mostrar detalle por documento cuando hay errores
            results
                .filter(r => r.status === "error")
                .forEach((r) => {
                    const docNum = r.DocNum ?? modalData?.DocNum;
                    const rawDetail = r.detalle ?? r.message ?? r.detalle?.value;
                    const detail = typeof rawDetail === "string"
                        ? rawDetail
                        : (rawDetail != null ? JSON.stringify(rawDetail, null, 2) : "Ocurrió un error.");
                    lines.push(`\nNro Documento: ${docNum || "(sin número)"}\nError: ${detail}`);
                });

            const messageText = lines.join("\n");
            setMessage(messageText);
            if (messageText) alert(messageText);

            setModalData(null);
            setEstablecimiento("");
            setPuntoEmision("");
            setNumeroFolio("");
            fetchItems(); // Refrescar listado
        } catch (error) {
            console.error("Error al recepcionar:", error);
            alert("Error al registrar la recepción.");
        }
    };

    return (
        <div className="container-fluid mt-3">
            <h2 className="text-center mb-3">Solicitudes de Traslado Pendientes</h2>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="row mb-3">
                <div className="col-12 col-md-6 mx-auto">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Buscar por Nro Documento, Proveedor, Fecha o Comentario"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <DataTable
                columns={columns}
                data={filteredOrders}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                pagination
                responsive
                dense
            />

            {modalData && (
                <div className="modal show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title">Recepción de Orden #{modalData.DocNum}</h6>
                                <button type="button" className="btn-close" onClick={() => setModalData(null)}></button>
                            </div>

                            <div className="modal-body">
                                <div className="row g-2 mb-3">
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Establecimiento</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={establecimiento}
                                            onChange={(e) => setEstablecimiento(e.target.value)}
                                            placeholder="Ej: 001"
                                        />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Punto de Emisión</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={puntoEmision}
                                            onChange={(e) => setPuntoEmision(e.target.value)}
                                            placeholder="Ej: 002"
                                        />
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <label className="form-label">Número de Folio</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={numeroFolio}
                                            onChange={(e) => setNumeroFolio(e.target.value)}
                                            placeholder="Ej: 1234"
                                        />
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-sm table-bordered">
                                        <thead>
                                            <tr>
                                                <th>ItemCode</th>
                                                <th>Descripción</th>
                                                <th>Fecha de Recepción</th>
                                                <th>Pendiente</th>
                                                <th>Recepcionado</th>
                                                <th>Comentario</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {modalData.Orders.map((line) => (
                                                <tr key={line.LineNum}>
                                                    <td>{line.ItemCode}</td>
                                                    <td>{line.Dscription}</td>
                                                    <td>{formatDateUTC(line.ShipDate)}</td>
                                                    <td>{line.OpenQty}</td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm"
                                                            value={recepcionData[line.LineNum] || ""}
                                                            onChange={(e) => {
                                                                const val = parseFloat(e.target.value);
                                                                const maxQty = line.Ajustable === "Y"
                                                                    ? line.OpenQty * 1.01
                                                                    : line.OpenQty;

                                                                if (val > maxQty) return; // bloquear si excede el máximo permitido
                                                                setRecepcionData(prev => ({
                                                                    ...prev,
                                                                    [line.LineNum]: e.target.value
                                                                }));
                                                            }}
                                                            min="0"
                                                            max={line.Ajustable === "Y" ? (line.OpenQty * 1.03).toFixed(2) : line.OpenQty}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className={`form-control form-control-sm ${(parseFloat(recepcionData[line.LineNum]) > 0 && ((comentariosPorLinea[line.LineNum] || "").trim().length < 10 || (comentariosPorLinea[line.LineNum] || "").trim().length > 100)) ? "is-invalid" : ""}`}
                                                            value={comentariosPorLinea[line.LineNum] || ""}
                                                            onChange={(e) => {
                                                                const inputValue = e.target.value;
                                                                setComentariosPorLinea(prev => ({
                                                                    ...prev,
                                                                    [line.LineNum]: inputValue
                                                                }));
                                                            }}
                                                            placeholder="mín. 10 / máx. 100"
                                                            maxLength={100}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setModalData(null)}>Cancelar</button>
                                <button className="btn btn-primary" onClick={confirmarRecepcion}>Confirmar Recepción</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

};

export default PlanifLines;
